import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useLanguage } from '../i18n/useLanguage';

const SignIn = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useLanguage();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    // Simple validation
    if (!userName || !password) {
      setError(t('auth.signin.errors.fieldsRequired'));
      setIsLoading(false);
      return;
    }
    
    try {
      await login({
        user_name: userName,
        password
      });
      // Success handling được xử lý trong AuthContext
    } catch (apiError) {
      setError(apiError.message || t('auth.signin.errors.invalidCredentials'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold">{t("auth.signin.appName")}</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">{t("auth.signin.title")}</p>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-8">
          {error && (
            <div className="bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 p-3 rounded-md mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="user_name"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >
                {t("auth.signin.usernameLabel")}
              </label>
              <input
                id="user_name"
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="form-input"
                placeholder={t("auth.signin.usernamePlaceholder")}
                disabled={isLoading}
              />
            </div>

            <div className="mb-6">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >
                {t("auth.signin.passwordLabel")}
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                disabled={isLoading}
              />
            </div>

            <button type="submit" className="w-full btn-primary" disabled={isLoading}>
              {isLoading ? t("auth.login.loading") : t("auth.signin.submitButton")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn; 